import React, { useEffect } from "react";
import TaskListItem from "./TaskListItem";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTaskDetail } from "../../actions/task";
import { formatDate } from "../../utils";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const TaskDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { taskDetail } = useSelector((state) => state.taskReducer);
  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  useEffect(() => {
    dispatch(fetchTaskDetail(id));
  }, [dispatch]);

  return (
    <div className="task-detail-main-container">
      <Breadcrumb title={t("taskDetail.breadcrumbTitle")} returnPage="/task" />

      <div className="task-detail-list-container">
        <div className="task-detail-info">
          <div className="task-list-item">
            <div className="task-list-item-header">
              <div className="task-list-item-header-title">
                {taskDetail?.name}
              </div>
              <div className="task-list-item-header-points">
                +{taskDetail?.experience} exp
              </div>
            </div>
            <div className="task-list-item-date">
              {t("taskDetail.taskExpiryDateLabel")}{" "}
              {formatDate(taskDetail?.endDate)}
            </div>
          </div>
        </div>
        <div className="task-list-item-context">
          <div className="task-list-item-context-list">
            {taskDetail?.items?.map((item, key) => (
              <TaskListItem item={item} key={key} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskDetail;
